export enum OrderTermFor {
  vendor = 'vendor',
  customer = 'customer',
  both = 'both',
}

export type OrderTermId = string;
export interface OrderTermResponse {
  id: OrderTermId;
  name: string;
  fixedDays?: number;
  dayOfMonth?: number;
  dayOfDueDate?: number;
}
